import { MODULES } from "./modulesConfig";
// Biblioteca de cards e seções configuráveis por módulo
// Extraído de App.jsx — Fase B

const MODULE_CARD_LIBRARY = {
  purchases: [
    { id:"orders", label:"Compras" },
    { id:"open_orders", label:"Pedidos em Aberto" },
    { id:"missing_approval", label:"Faltando Aprovação" },
    { id:"in_transit", label:"Em Trânsito" },
    { id:"quotes", label:"Cotações" },
    { id:"denied_orders", label:"Negados" },
    { id:"approvals", label:"Aprovações" },
    { id:"suppliers", label:"Fornecedores" },
  ],
  animals: [
    { id:"bovinos", label:"Bovinos" },
    { id:"ovinos", label:"Ovinos" },
    { id:"equinos", label:"Equinos" },
    { id:"bovino_animais", label:"Bovinos · Animais Individuais" },
    { id:"bovino_lotes", label:"Bovinos · Lotes de Animais" },
    { id:"bovino_animais_cadastro", label:"Bovinos Ativos" },
    { id:"bovino_animais_nutricao", label:"Animais em Lotes" },
    { id:"bovino_animais_medicamentos", label:"Bovinos Cadastrados" },
    { id:"bovino_lotes_resumo", label:"Bovinos de 0 a 12 Meses" },
    { id:"bovino_lotes_edicao", label:"Bovinos de 13 a 24 Meses" },
    { id:"bovino_lotes_nutricao", label:"Bovinos de 25 a 36 Meses" },
    { id:"bovino_lotes_medicamentos", label:"Bovinos Acima de 36 Meses" },
    { id:"ovino_animais", label:"Ovinos · Animais Individuais" },
    { id:"ovino_lotes", label:"Ovinos · Lotes de Animais" },
    { id:"ovino_animais_cadastro", label:"Ovinos · Animais Individuais · Cadastro" },
    { id:"ovino_animais_nutricao", label:"Ovinos · Animais Individuais · Nutrição" },
    { id:"ovino_animais_medicamentos", label:"Ovinos · Animais Individuais · Medicamentos" },
    { id:"ovino_lotes_resumo", label:"Ovinos · Lotes de Animais · Lotes" },
    { id:"ovino_lotes_edicao", label:"Ovinos · Lotes de Animais · Editar Lote" },
    { id:"ovino_lotes_nutricao", label:"Ovinos · Lotes de Animais · Nutrição" },
    { id:"ovino_lotes_medicamentos", label:"Ovinos · Lotes de Animais · Medicamentos" },
    { id:"equino_potros", label:"Equinos · Potros" },
    { id:"equino_servico", label:"Equinos · Animais de Serviço" },
    { id:"equino_nutricao", label:"Equinos · Nutrição" },
    { id:"equino_medicamentos", label:"Equinos · Medicamentos" },
    { id:"potros_cadastro", label:"Potros · Cadastro" },
    { id:"potros_nutricao", label:"Potros · Nutrição" },
    { id:"potros_medicamentos", label:"Potros · Medicamentos" },
    { id:"potros_historico", label:"Potros · Histórico" },
    { id:"servico_cadastro", label:"Animais de Serviço · Cadastro" },
    { id:"servico_nutricao", label:"Animais de Serviço · Nutrição" },
    { id:"servico_medicamentos", label:"Animais de Serviço · Medicamentos" },
    { id:"servico_historico", label:"Animais de Serviço · Histórico" },
  ],
  aviculture: [
    { id:"aves_1_dia", label:"Aves de 1 Dia" },
    { id:"aves_crescimento", label:"Aves Crescimento" },
    { id:"aves_corte", label:"Aves Corte" },
    { id:"aves_postura", label:"Aves Postura" },
    { id:"day1_lotes", label:"Aves de 1 Dia · Lotes" },
    { id:"day1_nutricao", label:"Aves de 1 Dia · Nutrição" },
    { id:"day1_medicamentos", label:"Aves de 1 Dia · Medicamentos" },
    { id:"day1_mortes", label:"Aves de 1 Dia · Mortes" },
    { id:"growth_lotes", label:"Aves Crescimento · Lotes" },
    { id:"growth_nutricao", label:"Aves Crescimento · Nutrição" },
    { id:"growth_medicamentos", label:"Aves Crescimento · Medicamentos" },
    { id:"growth_mortes", label:"Aves Crescimento · Mortes" },
    { id:"corte_lotes", label:"Aves Corte · Lotes" },
    { id:"corte_nutricao", label:"Aves Corte · Nutrição" },
    { id:"corte_medicamentos", label:"Aves Corte · Medicamentos" },
    { id:"corte_mortes", label:"Aves Corte · Mortes" },
    { id:"postura_lotes", label:"Aves Postura · Lotes" },
    { id:"postura_nutricao", label:"Aves Postura · Nutrição" },
    { id:"postura_medicamentos", label:"Aves Postura · Medicamentos" },
    { id:"postura_ovos", label:"Aves Postura · Ovos" },
  ],
  financial: [
    { id:"receitas", label:"Receitas" },
    { id:"despesas", label:"Despesas" },
    { id:"saldo", label:"Saldo" },
    { id:"consumo_estoque_rs", label:"Consumo Estoque R$" },
    { id:"resultado_operacional", label:"Resultado Operacional" },
    { id:"descartes", label:"Descartes" },
    { id:"transferencias_saida", label:"Transferências Saída" },
    { id:"transferencias_entrada", label:"Transferências Entrada" },
    { id:"lancamentos_total", label:"Lançamentos" },
    { id:"lancamentos_receitas", label:"Lançamentos · Receitas" },
    { id:"lancamentos_despesas", label:"Lançamentos · Despesas" },
    { id:"lancamentos_bloqueios", label:"Lançamentos · Bloqueios" },
    { id:"folha_colaboradores_ativos", label:"Folha · Colaboradores Ativos" },
    { id:"folha_base_salarial", label:"Folha · Base Salarial" },
    { id:"folha_encargos", label:"Folha · Encargos" },
    { id:"folha_custo_estimado", label:"Folha · Custo Estimado" },
    { id:"conciliados", label:"Conciliados" },
    { id:"em_aberto", label:"Em Aberto" },
    { id:"vencidos", label:"Vencidos" },
    { id:"liquidados_pendentes", label:"Liquidados Pendentes" },
    { id:"contas_ativas", label:"Contas Ativas" },
    { id:"centros_ativos", label:"Centros Ativos" },
    { id:"origens_automaticas", label:"Origens Automáticas" },
    { id:"dias_fluxo", label:"Dias com Fluxo" },
    { id:"receita_bruta", label:"Receita Bruta" },
    { id:"deducoes_tributos", label:"Deduções / Tributos" },
    { id:"custo_estoque", label:"Custo de Estoque" },
    { id:"pendencias_documento", label:"Pendências de Documento" },
    { id:"pendencias_vencidas", label:"Pendências Vencidas" },
    { id:"problemas_tributarios", label:"Problemas Tributários" },
    { id:"alertas_fechamento", label:"Alertas de Fechamento" },
    { id:"fechamento_lancamentos", label:"Fechamento · Lançamentos" },
    { id:"fechamento_bloqueios", label:"Fechamento · Bloqueios" },
    { id:"fechamento_avisos", label:"Fechamento · Avisos" },
    { id:"fechamento_status", label:"Fechamento · Status" },
  ],
  hr: [
    { id:"numero_colaboradores", label:"Número de Colaboradores" },
    { id:"equipamentos_entregues", label:"Número de Equipamentos Entregues" },
    { id:"epis_entregues", label:"Número de EPIs Entregues" },
    { id:"conferencia_epis", label:"Conferência de EPIs" },
    { id:"conferencia_equipamentos", label:"Conferência de Equipamentos" },
  ],
  my_items: [
    { id:"equipamentos", label:"Equipamentos" },
    { id:"epis", label:"EPIs" },
    { id:"vistorias", label:"Vistorias" },
    { id:"itens_visualizados", label:"Itens Visualizados" },
  ],
  vet: [
    { id:"agenda", label:"Agenda" },
    { id:"medicamentos", label:"Medicamentos" },
    { id:"procedimentos", label:"Procedimentos" },
    { id:"historico", label:"Histórico" },
  ],
  stock: [
    { id:"duracao_racao_bovinos", label:"Duração de Ração · Bovinos" },
    { id:"duracao_suplemento_bovinos", label:"Duração de Suplemento · Bovinos" },
    { id:"duracao_racao_equinos", label:"Duração de Ração · Equinos" },
    { id:"duracao_racao_aves_postura", label:"Duração de Ração · Aves Postura" },
    { id:"catalogo", label:"Catálogo" },
    { id:"movimentacoes", label:"Movimentações" },
  ],
  machinery: [
    { id:"maquinas_operacionais", label:"Máquinas Operacionais" },
    { id:"maquinas_inativas", label:"Máquinas Inativas" },
    { id:"implementos", label:"Implementos" },
    { id:"maquinas_manutencao", label:"Máquinas em Manutenção" },
    { id:"manutencoes_agendadas", label:"Manutenções Agendadas" },
    { id:"manutencoes_em_dia", label:"Manutenções em Dia" },
    { id:"manutencoes_atrasadas", label:"Manutenções Atrasadas" },
    { id:"manutencoes_pausadas", label:"Manutenções Pausadas" },
    { id:"manutencoes_corretivas", label:"Manutenções Corretivas" },
    { id:"abastecimentos_mes", label:"Número de Abastecimentos no Mês" },
    { id:"total_abastecido_mes", label:"Total Abastecido no Mês" },
    { id:"alertas_estoque", label:"Alertas de Estoque" },
    { id:"consumo_diesel_medio_3m", label:"Consumo Diesel Médio Mensal (últimos 3 meses)" },
  ],
  haras: [
    { id:"numero_equinos", label:"Número de Equinos" },
    { id:"numero_garanhoes", label:"Número de Garanhões" },
    { id:"numero_eguas", label:"Número de Éguas" },
    { id:"numero_baias", label:"Número de Baias" },
    { id:"treinos_agendados_semana", label:"Número de Treinos Agendados na Semana" },
    { id:"manejos_agendados_semana", label:"Número de Manejos Agendados na Semana" },
    { id:"treinos_realizados_semana", label:"Número de Treinos Realizados na Semana" },
    { id:"manejos_realizados_semana", label:"Número de Manejos Realizados na Semana" },
    { id:"baias_conformes_semana", label:"Baias Conformes Medida Semanal" },
    { id:"baias_nao_conformes_semana", label:"Baias Não Conformes Medida Semanal" },
    { id:"vistorias_agendadas_mensal", label:"Vistorias Agendadas Mensal" },
    { id:"vistorias_realizadas_mensal", label:"Vistorias Realizadas Mensal" },
    { id:"estoque_racao", label:"Estoque de Ração" },
    { id:"consumo_sacos_racao_semanal", label:"Consumo de Sacos de Ração Semanal" },
    { id:"consumo_racao_animal_dia", label:"Consumo de Ração Animal Dia" },
    { id:"estoque_feno", label:"Estoque de Feno" },
    { id:"consumo_feno_semanal", label:"Consumo Feno Semanal" },
    { id:"consumo_feno_animal_dia", label:"Consumo Diário de Feno por Animal" },
  ],
  pastures: [
    { id:"pastos", label:"Pastos" },
    { id:"area_total", label:"Área Total" },
    { id:"pontos_interesse", label:"Pontos de Interesse" },
    { id:"capacidade_animais", label:"Capacidade de Animais" },
    { id:"pontos_ativos", label:"Pontos Ativos" },
    { id:"em_manutencao", label:"Em manutenção" },
    { id:"serv_pausados", label:"Serv. Pausados" },
    { id:"serv_agendados", label:"Serv. Agendados" },
    { id:"sujos_muito_sujos", label:"Sujos/Muito Sujos" },
  ],
  sede: [
    { id:"visao_geral", label:"Visão Geral" },
    { id:"compras_sede", label:"Compras" },
    { id:"servicos_sede", label:"Serviços" },
    { id:"ocorrencias_sede", label:"Ocorrências" },
  ],
  services: [
    { id:"abertas", label:"Abertos" },
    { id:"em_execucao", label:"Em Execução" },
    { id:"aguardando_decisao", label:"Aguardando Decisão" },
    { id:"concluidas", label:"Concluídos" },
  ],
  services_external: [
    { id:"abertas", label:"Abertas" },
    { id:"em_execucao", label:"Em Execução" },
    { id:"aguardando_decisao", label:"Aguardando Decisão" },
    { id:"concluidas", label:"Concluídas" },
    { id:"prestadores", label:"Prestadores" },
    { id:"materiais", label:"Materiais" },
  ],
  inspections: [
    { id:"total", label:"Total" },
    { id:"conforme", label:"Conforme" },
    { id:"com_atencao", label:"Com Atenção" },
    { id:"nao_conformes", label:"Não Conformes" },
  ],
  occurrences: [
    { id:"abertas", label:"Abertas" },
    { id:"em_execucao", label:"Em Execução" },
    { id:"aguardando_decisao", label:"Aguardando Decisão" },
    { id:"concluidas", label:"Concluídas" },
    { id:"materiais", label:"Materiais" },
    { id:"fotos", label:"Fotos" },
  ],
};

const MODULE_CARD_SECTION_LIBRARY = {
  purchases: [
    { id:"moduleHome", label:"Página Principal", cards:["orders","open_orders","missing_approval","in_transit","quotes","approvals","suppliers"] },
  ],
  animals: [
    { id:"moduleHome", label:"Página Principal", cards:["bovinos","ovinos","equinos"] },
    { id:"menus", label:"Menus", children:[
      { id:"menu:bovinos", label:"Menu Bovinos", children:[
        { id:"submenu:bovinos:animais", label:"Submenu Animais Individuais", cards:["bovino_animais_cadastro","bovino_animais_nutricao","bovino_animais_medicamentos"] },
        { id:"submenu:bovinos:lotes", label:"Submenu Lotes de Animais", cards:["bovino_lotes_resumo","bovino_lotes_edicao","bovino_lotes_nutricao","bovino_lotes_medicamentos"] },
      ]},
      { id:"menu:ovinos", label:"Menu Ovinos", cards:["ovino_animais","ovino_lotes"], children:[
        { id:"submenu:ovinos:animais", label:"Submenu Animais Individuais", cards:["ovino_animais_cadastro","ovino_animais_nutricao","ovino_animais_medicamentos"] },
        { id:"submenu:ovinos:lotes", label:"Submenu Lotes de Animais", cards:["ovino_lotes_resumo","ovino_lotes_edicao","ovino_lotes_nutricao","ovino_lotes_medicamentos"] },
      ]},
      { id:"menu:equinos", label:"Menu Equinos", cards:["equino_potros","equino_servico"], children:[
        { id:"submenu:equinos:potros", label:"Submenu Potros", cards:["potros_cadastro","potros_nutricao","potros_medicamentos","potros_historico"] },
        { id:"submenu:equinos:servico", label:"Submenu Animais de Serviço", cards:["servico_cadastro","servico_nutricao","servico_medicamentos","servico_historico"] },
      ]},
    ]},
  ],
  aviculture: [
    { id:"moduleHome", label:"Página Principal", cards:["aves_1_dia","aves_crescimento","aves_corte","aves_postura"] },
    { id:"menus", label:"Menus", children:[
      { id:"menu:aves_1_dia", label:"Menu Aves de 1 Dia", cards:["day1_lotes","day1_nutricao","day1_medicamentos","day1_mortes"] },
      { id:"menu:aves_crescimento", label:"Menu Aves Crescimento", cards:["growth_lotes","growth_nutricao","growth_medicamentos","growth_mortes"] },
      { id:"menu:aves_corte", label:"Menu Aves Corte", cards:["corte_lotes","corte_nutricao","corte_medicamentos","corte_mortes"] },
      { id:"menu:aves_postura", label:"Menu Aves Postura", cards:["postura_lotes","postura_nutricao","postura_medicamentos","postura_ovos"] },
    ]},
  ],
  financial: [
    { id:"moduleHome", label:"Página Principal", cards:["receitas","despesas","saldo","consumo_estoque_rs","resultado_operacional","descartes"] },
    { id:"menus", label:"Menus", children:[
      { id:"menu:entries", label:"Menu Lançamentos", cards:["lancamentos_total","lancamentos_receitas","lancamentos_despesas","lancamentos_bloqueios"] },
      { id:"menu:payroll", label:"Menu Folha", cards:["folha_colaboradores_ativos","folha_base_salarial","folha_encargos","folha_custo_estimado"] },
      { id:"menu:stock", label:"Menu Estoque", cards:["consumo_estoque_rs","descartes","transferencias_saida","transferencias_entrada"] },
      { id:"menu:reconciliation", label:"Menu Conciliação", cards:["conciliados","em_aberto","vencidos","liquidados_pendentes"] },
      { id:"menu:reports", label:"Menu Relatórios", cards:["contas_ativas","centros_ativos","origens_automaticas","dias_fluxo"] },
      { id:"menu:dre", label:"Menu DRE", cards:["receita_bruta","deducoes_tributos","custo_estoque","resultado_operacional"] },
      { id:"menu:pending", label:"Menu Rastreio", cards:["pendencias_documento","pendencias_vencidas","problemas_tributarios","alertas_fechamento"] },
      { id:"menu:closing", label:"Menu Fechamento", cards:["fechamento_lancamentos","fechamento_bloqueios","fechamento_avisos","fechamento_status"] },
    ]},
  ],
  hr: [
    { id:"moduleHome", label:"Página Principal", cards:["numero_colaboradores","equipamentos_entregues","epis_entregues","conferencia_epis","conferencia_equipamentos"] },
    { id:"menus", label:"Menus", children:[
      { id:"menu:colaboradores", label:"Menu Colaboradores", cards:["numero_colaboradores","equipamentos_entregues","epis_entregues","conferencia_epis","conferencia_equipamentos"] },
      { id:"menu:epis_equipamentos", label:"Menu EPIs e Equipamentos", cards:["equipamentos_entregues","epis_entregues","conferencia_epis","conferencia_equipamentos"] },
    ]},
  ],
  my_items: [
    { id:"moduleHome", label:"Página Principal", cards:["equipamentos","epis","vistorias","itens_visualizados"] },
  ],
  vet: [
    { id:"moduleHome", label:"Página Principal", cards:["agenda","medicamentos","procedimentos","historico"] },
    { id:"menus", label:"Menus", children:[
      { id:"menu:atendimentos", label:"Menu Atendimentos", cards:["agenda","medicamentos","procedimentos","historico"], children:[
        { id:"submenu:atendimentos:individuais", label:"Submenu Individuais", cards:["agenda","medicamentos","procedimentos","historico"] },
        { id:"submenu:atendimentos:lotes", label:"Submenu Lotes", cards:["agenda","medicamentos","procedimentos","historico"] },
        { id:"submenu:atendimentos:agenda", label:"Submenu Agenda", cards:["vet_agendados","vet_realizados","vet_nao_realizados","vet_em_andamento"] },
      ] },
    ]},
  ],
  stock: [
    { id:"moduleHome", label:"Página Principal", cards:["duracao_racao_bovinos","duracao_suplemento_bovinos","duracao_racao_equinos","duracao_racao_aves_postura"] },
    { id:"menus", label:"Menus", children:[
      { id:"menu:estoque", label:"Menu Estoque", cards:["duracao_racao_bovinos","duracao_suplemento_bovinos","duracao_racao_equinos","duracao_racao_aves_postura"] },
    ]},
  ],
  machinery: [
    { id:"moduleHome", label:"Página Principal", cards:["maquinas_operacionais","maquinas_inativas","implementos","maquinas_manutencao"] },
    { id:"menus", label:"Menus", children:[
      { id:"menu:manutencao", label:"Menu Manutenção", cards:[], children:[
        { id:"submenu:manutencao:agenda", label:"Submenu Agenda", cards:["manutencoes_agendadas","manutencoes_em_dia","manutencoes_atrasadas","manutencoes_pausadas","manutencoes_corretivas"] },
        { id:"submenu:manutencao:lista", label:"Submenu Lista", cards:["manutencoes_agendadas","manutencoes_em_dia","manutencoes_atrasadas","manutencoes_pausadas","manutencoes_corretivas"] },
     ] },
      { id:"menu:abastecimento", label:"Menu Abastecimento", cards:["abastecimentos_mes","total_abastecido_mes","alertas_estoque","consumo_diesel_medio_3m"] },
    ]},
  ],
  haras: [
    { id:"moduleHome", label:"Página Principal", cards:["numero_equinos","numero_garanhoes","numero_eguas","numero_baias"] },
    { id:"menus", label:"Menus", children:[
      { id:"menu:agenda", label:"Menu Agenda", cards:["treinos_agendados_semana","manejos_agendados_semana","treinos_realizados_semana","manejos_realizados_semana"] },
      { id:"menu:baias", label:"Menu Baias", cards:["baias_conformes_semana","baias_nao_conformes_semana","vistorias_agendadas_mensal","vistorias_realizadas_mensal"] },
      { id:"menu:nutricao", label:"Menu Nutrição", cards:["estoque_racao","consumo_sacos_racao_semanal","consumo_racao_animal_dia","estoque_feno","consumo_feno_semanal","consumo_feno_animal_dia"] },
      { id:"menu:plantel", label:"Menu Plantel", cards:["numero_equinos","numero_garanhoes","numero_eguas","numero_baias"] },
    ]},
  ],
  pastures: [
    { id:"moduleHome", label:"Página Principal", cards:["pastos","area_total","pontos_interesse","capacidade_animais"] },
    { id:"menus", label:"Menus", children:[
      { id:"menu:lugares", label:"Menu Lugares", cards:["pastos","area_total","capacidade_animais","sujos_muito_sujos"] },
      { id:"menu:pontos_interesse", label:"Menu Pontos de Interesse", cards:["pontos_ativos","em_manutencao","serv_pausados","serv_agendados"] },
    ]},
  ],
  sede: [
    { id:"moduleHome", label:"Página Principal", cards:["visao_geral","compras_sede","servicos_sede","ocorrencias_sede"] },
  ],
  services: [
    { id:"moduleHome", label:"Página Principal", cards:["abertas","em_execucao","aguardando_decisao","concluidas"] },
  ],
  services_external: [
    { id:"moduleHome", label:"Página Principal", cards:["abertas","em_execucao","aguardando_decisao","concluidas"] },
  ],
  inspections: [
    { id:"moduleHome", label:"Página Principal", cards:["total","conforme","com_atencao","nao_conformes"] },
  ],
  occurrences: [
    { id:"moduleHome", label:"Página Principal", cards:["abertas","em_execucao","aguardando_decisao","concluidas"] },
  ],
};

function getModuleCardSections(moduleId){
  const configured = Array.isArray(MODULE_CARD_SECTION_LIBRARY[moduleId]) ? MODULE_CARD_SECTION_LIBRARY[moduleId] : null;
  if (configured?.length) return configured;
  const fallbackCards = getModuleCardLibrary(moduleId).map(card=>card.id);
  return [
    { id:"moduleHome", label:"Página Principal", cards:fallbackCards.slice(0,4) },
    { id:"menus", label:"Menus", children:[
      { id:"menu:principal", label:"Menu Principal", cards:fallbackCards.slice(0,4) },
    ]},
  ];
}

function flattenModuleCardSections(sections){
  const list = [];
  const walk = (items)=>{
    (Array.isArray(items) ? items : []).forEach(section=>{
      list.push(section);
      if (Array.isArray(section.children) && section.children.length) walk(section.children);
    });
  };
  walk(sections);
  return list;
}

function getModuleCardLibrary(moduleId){
  const source = Array.isArray(MODULE_CARD_LIBRARY[moduleId]) ? MODULE_CARD_LIBRARY[moduleId] : [];
  if (source.length) return source;
  return [
    { id:"overview", label:"Visão Geral" },
    { id:"cadastros", label:"Cadastros" },
    { id:"operacoes", label:"Operações" },
    { id:"historico", label:"Histórico" },
  ];
}

function normalizeModuleCardsConfig(input){
  const source = input && typeof input === "object" ? input : {};
  const normalized = {};
  for(const mod of MODULES.filter(m=>!m.hidden)){
    const cards = getModuleCardLibrary(mod.id);
    const cardIds = new Set(cards.map(card=>card.id));
    const sections = flattenModuleCardSections(getModuleCardSections(mod.id));
    const current = source?.[mod.id] && typeof source[mod.id] === "object" ? source[mod.id] : {};
    normalized[mod.id] = {};
    for(const section of sections){
      const rawCards = Array.isArray(current?.[section.id]) ? current[section.id] : [];
      normalized[mod.id][section.id] = [...new Set(rawCards.map(v=>String(v||"").trim()).filter(v=>cardIds.has(v)))];
    }
  }
  return normalized;
}

export {
  MODULE_CARD_LIBRARY,
  MODULE_CARD_SECTION_LIBRARY,
  getModuleCardSections,
  flattenModuleCardSections,
  getModuleCardLibrary,
  normalizeModuleCardsConfig,
};
